
import { useState, useEffect } from "react";
import { adminLinks, ownerLinks } from "./navigationLinks";
import { useAccessControls } from "@/hooks/useAccessControls";
import { useMenuVisibility } from "@/hooks/useMenuVisibility";
import { useFilteredLinks } from "@/hooks/sidebar/useFilteredLinks";
import { useFeatureVisibility } from "@/hooks/sidebar/useFeatureVisibility";
import { useAccessCodesState } from "@/hooks/sidebar/useAccessCodesState";

export const useSidebarState = (userType: "admin" | "owner") => {
  const links = userType === "admin" ? adminLinks : ownerLinks;
  const { accessControls, refetch } = useAccessControls(userType);
  
  const { authorizedFeatures, accessCodes } = useAccessCodesState(accessControls);
  
  const {
    visibleMenuItems,
    selectedMenuItem,
    isDialogOpen,
    setIsDialogOpen,
    setSelectedMenuItem,
    toggleMenuItemVisibility,
    setVisibleMenuItems,
  } = useMenuVisibility(accessControls, links, refetch);

  const filteredLinks = useFilteredLinks(userType, links);

  const {
    isFeatureDisabled,
    shouldShowEyeIcon,
    isFeatureVisible,
  } = useFeatureVisibility(authorizedFeatures, accessCodes, visibleMenuItems);

  // Effect to initialize visibility state from localStorage
  useEffect(() => {
    const tabMaskingEnabled = localStorage.getItem('tabMaskingEnabled');
    if (tabMaskingEnabled === null) {
      localStorage.setItem('tabMaskingEnabled', 'false');
    }
  }, []);

  const handleEyeClick = (name: string, feature?: string) => {
    // Bascule direct de la visibilité sans vérification du code d'accès
    if (feature) {
      toggleMenuItemVisibility(feature);
    }
  };

  return {
    authorizedFeatures,
    visibleMenuItems,
    accessCodes,
    selectedMenuItem,
    isDialogOpen,
    filteredLinks,
    setIsDialogOpen,
    setSelectedMenuItem,
    handleEyeClick,
    toggleMenuItemVisibility,
    shouldShowEyeIcon,
    isFeatureVisible,
  };
};
